/* ==========================================================
   Slideshow: hace clickeable toda la diapositiva.
   Toma la URL del botón de cada slide ("Enlace del botón")
   y la aplica a un enlace invisible que cubre la imagen.
   Cuando el slide tiene enlace se marca con la clase
   .has-full-link y el botón se oculta por CSS.
   Si un slide no tiene enlace configurado, el botón se
   muestra como siempre y no pasa nada más.
   ========================================================== */
(function () {
  var WRAP_SELECTOR = '.slideshow__item-wrap';

  function apply(root) {
    var wraps = (root || document).querySelectorAll(WRAP_SELECTOR);

    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var bg = wrap.querySelector('.slideshow__bg');
      if (!bg) continue;

      var btn = wrap.querySelector('.slideshow__buttons a[href]');
      var href = btn ? btn.getAttribute('href') : '';
      var link = bg.querySelector('.slide-full-link');

      if (!href || href === '#') {
        if (link && link.parentNode) link.parentNode.removeChild(link);
        wrap.classList.remove('has-full-link');
        continue;
      }

      if (!link) {
        link = document.createElement('a');
        link.className = 'slide-full-link';
        bg.appendChild(link);
      }

      link.setAttribute('href', href);

      var label = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label) {
        var heading = wrap.querySelector('.slideshow__title');
        label = heading ? (heading.textContent || '').replace(/\s+/g, ' ').trim() : '';
      }
      if (label) link.setAttribute('aria-label', label);

      if (btn.getAttribute('target')) {
        link.setAttribute('target', btn.getAttribute('target'));
      }

      wrap.classList.add('has-full-link');
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  var observed = [];
  function watchSliders() {
    var wrappers = document.querySelectorAll('slideshow-component .swiper-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      if (observed.indexOf(wrappers[i]) !== -1) continue;
      observed.push(wrappers[i]);
      new MutationObserver(schedule).observe(wrappers[i], { childList: true });
    }
  }

  function init() {
    apply();
    watchSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', schedule);

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 50);
  });
})();